import { IconBell } from "@suse-o11y/icons";
import React from "react";

import { Permission } from "~/models/dto";

import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { NOTIFICATIONS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemNotifications: React.FC = () => {
	const permissions = usePermissions();
	const link = useNavigateToLink(NOTIFICATIONS_PATH, {
		params: {},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!permissions?.hasSystemPermission(Permission.GetNotifications)) {
		return null;
	}

	return (
		<MainMenuItemLayout
			icon={<IconBell className="text-grey-800" height={22} width={18} />}
			label="Notifications"
			to={link}
		/>
	);
};
